module.exports = __webpack_public_path__ + "static/media/trades-count-bonus-mobile-header-image.dfde099c.png";